<template>
  <div :class="$style['pt-system-user-detail']">
    <pt-page-title title="系统用户详情"></pt-page-title>
    <pt-sub-title title="系统用户信息"></pt-sub-title>
    <div v-if="currentData && currentData.organizationUser">
      <pt-form-item
        label="用户名："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
        <span>{{ currentData.organizationUser.username }}</span>
      </pt-form-item>
      <pt-form-item
        label="所属单位："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
        <span>{{ currentData.organizationName }}</span>
      </pt-form-item>
      <pt-form-item
        label="姓名："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
        <span>{{ currentData.organizationUser.firstName }}</span>
      </pt-form-item>
      <pt-form-item
        label="性别："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
        <span>{{ currentData.organizationUser.gender_text }}</span>
      </pt-form-item>
      <pt-form-item
        label="手机号："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
        <span>{{ currentData.organizationUser.mobile }}</span>
      </pt-form-item>
      <pt-form-item
        label="系统用户角色："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
        <span>{{ currentData.roleDisplayName.toString() }}</span>
      </pt-form-item>
			<pt-form-item
				label="所属科室："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight">
				<span>{{currentData.departmentDisplayName.toString()}}</span>
				</pt-form-item>
      <pt-form-item
        label="创建人："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
        <p>
          <span>{{ currentData.organizationUser.createdBy}}</span>
          <span style="margin-left:10px">{{ currentData.organizationUser.created_date }}</span>
        </p>
       
      </pt-form-item>
      <pt-form-item
        label="最近编辑："
        :labelColor="labelColor"
        :labelWidth="labelWidth"
        :lineHeight="lineHeight"
      >
         <p>
          <span>{{ currentData.organizationUser.lastModifiedBy}}</span>
          <span style="margin-left:10px">{{ currentData.organizationUser.last_modified_date }}</span>
        </p>
       
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(currentData.organizationUser.userLogin)">编辑</el-button>
      <el-button plain type="primary" @click="cancel()">取消</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = "pt-system-user-detail";

export default {
  name: "pt-system-user-detail",
  computed: {
    classes() {
      return `${prefixCls}`;
    }
  },
  props: {
    detail: {
      type: Object,
      default: () => {
        return {
          base: {}
        }
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  watch: {
    detail (val) {
      this.currentData = val
    }
  },
  data () {
    return {
      labelColor: '#409eff',
      labelWidth: '150px',
      lineHeight: '26',
      currentData: this.detail
    }
  },
  methods: {
    goEdit (id) {
      this.$router.push(`/system-customer-form/true/${id}`)
    },
    cancel(){
      this.$router.go(-1)
    }
  }
};
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-system-user-detail{
  color: #6D6D6D;
}
</style>
